import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { HalfNameMarkReport } from './Pages/listing';

export const HalfNameMarkReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={HalfNameMarkReport} />
    </Fragment>
)